export const SMARTPHONE_MAX_WIDTH = 1224;
export const PC_MIN_WIDTH = 1224;
